import { render } from "./App.vue?vue&type=template&id=4dbe35b6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4dbe35b6&lang=stylus"

import exportComponent from "K:\\ダウンロード\\JASRAC対応\\新しいフォルダー\\東京書籍様_JASRACマーク実装_納品データ\\東京書籍様_JASRACマーク実装_納品データ-最終作業用\\e_5\\e_5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__